import { record, pack } from 'rrweb'
import axios from 'axios'
import configObj from './config'

const events = []
let tempVideoRecordUid = ''

export const setTempVideoRecordUid = (uid = '') => {
  tempVideoRecordUid = uid || ''
}

/**
 * 初始化视频录制
 * @param {*} mobile 当前用户手机号
 * @returns 初始化视频录制失败返回错误信息，上报给problem接口
 */
export const tempHandleInitVideoRecord = (mobile, hasReturnData) => {
  if (!mobile) return '手机号不存在 || 用户未登录'
  handleInitLocalStorage('temp-video-record-mobile', 'temp-video-record-events-start-time', 'temp-video-record-events', mobile)
  if (location.pathname.endsWith('/unicom/app/issue')) {
    if (localStorage.getItem('temp-video-record-events') !== '[]') return '本地还有记录，上报后再录屏'
    return false
  } else {
    // 本来应该判断hasReturnData，但是从三方回来，录屏不能续上，所以干脆直接清空
    localStorage.removeItem('temp-video-record-events-start-time')
    localStorage.removeItem('temp-video-record-mobile')
    localStorage.removeItem('temp-video-record-events')
    handleInitLocalStorage('temp-video-record-mobile', 'temp-video-record-events-start-time', 'temp-video-record-events', mobile)
    const error = handleStartVideoRecord()
    if (error) return error
    return false
  }
}

/**
 * 初始化本地存储
 * @param {*} mobileKey 上一次的用户手机号
 * @param {*} timeKey 上一次的录制开始时间
 * @param {*} eventsKey 上一次的录制事件
 * @param {*} mobile 当前的用户手机号
 */
const handleInitLocalStorage = (mobileKey, timeKey, eventsKey, mobile) => {
  if (!localStorage.getItem(mobileKey)) localStorage.setItem(mobileKey, mobile)
  if (!localStorage.getItem(timeKey)) localStorage.setItem(timeKey, new Date().toLocaleString().replace(/[/:]/g, '_'))
  if (!localStorage.getItem(eventsKey)) localStorage.setItem(eventsKey, JSON.stringify([]))
}

/**
 * 开始录制视频
 * @returns 开始录制视频失败返回错误信息
 */
const handleStartVideoRecord = () => {
  let err = ''
  try {
    record({
      emit (event) {
        events.push(event)
        handleSaveLocalStorage(events)
      },
      packFn: pack,
      checkoutEveryNms: 10 * 60 * 1000, // 全量快照时间间隔
      sampling: {
        mousemove: false, // 不录制鼠标移动事件
        mouseInteraction: false, // 不录制鼠标交互事件
        scroll: 150, // 每 150ms 最多触发一次滚动交互
        media: false, // 关闭媒体录制
        input: 'last' // 连续输入时只录制最终值
      }
    })
  } catch (error) {
    err = error
  }
  return err
}

/**
 * 上传视频录制数据
 * @param {*} mobile 当前用户手机号
 */
export const tempHandleUploadVideoRecord = (mobile) => {
  const recordStartTime = localStorage.getItem('temp-video-record-events-start-time')
  const uploadEvents = JSON.parse(localStorage.getItem('temp-video-record-events'))
  const uploadMobile = localStorage.getItem('temp-video-record-mobile')
  if (uploadEvents.length) {
    return axios({
      method: 'post',
      url: configObj.videoRecordUrl,
      data: { events: uploadEvents, mobile: uploadMobile, uid: tempVideoRecordUid, recordStartTime },
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      }
    }).then(() => {
      events.length = 0
      localStorage.removeItem('temp-video-record-events-start-time')
      localStorage.removeItem('temp-video-record-mobile')
      localStorage.removeItem('temp-video-record-events')
      handleInitLocalStorage('temp-video-record-mobile', 'temp-video-record-events-start-time', 'temp-video-record-events', mobile)
    })
  }
}

const handleSaveLocalStorage = (events) => {
  const jsonString = JSON.stringify(events)
  const sizeInBytes = new Blob([jsonString]).size
  if (sizeInBytes < 2 * 1024 * 1024) {
    localStorage.setItem('temp-video-record-events', JSON.stringify(events))
  }
}
